import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateMeterNodeDialogComponent } from './update-meter-node-dialog.component';
import { CardDialogModule } from '../card-dialog/card-dialog.module';
import { MaterialModule } from 'src/app/core/material/material.module';
import { BaseModule } from 'src/app/core/base/base.module';



@NgModule({
  declarations: [
    UpdateMeterNodeDialogComponent
  ],
  imports: [
    CommonModule,
    CardDialogModule,
    MaterialModule,
    BaseModule
  ],
  exports: [
    UpdateMeterNodeDialogComponent
  ]
})
export class UpdateMeterNodeDialogModule { }
